import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TokenPowerBI } from '../interfaces/TokenPowerBI.interface';
import { BASE_API_URL_REPORTES } from '../constants';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})

/**
 * Service to make HTTP calls
 */
export class PowerBiService {
  constructor(private httpClient: HttpClient) {}

  private tokenUrl = 'https://login.microsoftonline.com/common/oauth2/token';

  getAuthToken(): Observable<TokenPowerBI> {
    return this.httpClient.get<TokenPowerBI>(environment.API_TOKEN_POWERBI_URL);
  }  

  async getReportData(authToken: string = '', idReporte: string = '') {
    const response = await fetch(BASE_API_URL_REPORTES + idReporte, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    });
    return response.json();
  }
}
